import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { HeaderIcon } from "@/components/Layout/header/HeaderIcon";
import "./HeaderMobileToggle.css";

export const HEADER_MOBILE_MENU_ID = "site-header-mobile-menu";

interface HeaderMobileToggleProps {
  open: boolean;
  onClick: () => void;
}

export const HeaderMobileToggle = forwardRef<
  HTMLButtonElement,
  HeaderMobileToggleProps
>(({ open, onClick }, ref) => {
  const { t } = useTranslation();

  return (
    <button
      ref={ref}
      type="button"
      className="site-header__mobile-toggle"
      onClick={onClick}
      aria-label={open ? t("a11y.closeMenu") : t("a11y.toggleMenu")}
      aria-expanded={open}
      aria-haspopup="dialog"
      aria-controls={HEADER_MOBILE_MENU_ID}
    >
      <HeaderIcon name={open ? "close" : "menu"} />
    </button>
  );
});

HeaderMobileToggle.displayName = "HeaderMobileToggle";
